import { useState } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { IconAngleRight, IconCalendar } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { PaymentPlanModalContent } from './RCFRepaymentSchedule/PaymentPlanModalContent';

export const ViewPaymentPlan = ({
    drawdownAmount,
    offer
}: {
    drawdownAmount: number;
    offer: TFormalOffer;
}) => {
    const [showPaymentPlan, setShowPaymentPlan] = useState(false);

    return (
        <>
            <Modal
                isOpen={showPaymentPlan}
                onClose={() => setShowPaymentPlan(false)}
                closeIcon
            >
                {showPaymentPlan && (
                    <PaymentPlanModalContent
                        offer={offer}
                        initialAmount={drawdownAmount}
                    />
                )}
            </Modal>

            <Button
                variant="tertiary"
                className="px-0"
                onClick={() => setShowPaymentPlan(true)}
            >
                <IconCalendar />
                <FormattedMessage
                    id="_.rcf_approved_view.offer_details_view_payment_plan"
                    defaultMessage="View payment plan"
                />
                <IconAngleRight />
            </Button>
        </>
    );
};
